import React from 'react';

import { IconButton } from '@mui/material';

import LogoutIcon from '@mui/icons-material/Logout';

import { ILogoutButtonViewProps } from './interfaces';

import { useStyles } from './styles';

const LogoutButtonView = ({
  logoutUser,
  iconColor,
  sx = {},
}: ILogoutButtonViewProps) => {
  const classes = useStyles(iconColor);
  const rootSx = { ...classes.root, ...sx };

  return (
    <IconButton onClick={logoutUser} sx={rootSx} disableRipple>
      <LogoutIcon />
    </IconButton>
  );
};

export default LogoutButtonView;
